import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 sm:py-12 px-2 sm:px-6 md:px-8 w-full overflow-x-hidden">
      <div className="max-w-3xl sm:max-w-4xl mx-auto">
        <div className="mb-6 sm:mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-emerald-600 hover:text-emerald-800 transition-colors mb-6"
          >
            <ArrowLeft className="w-4 h-4 mr-1" />
            Back to Home
          </Link>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">Cookie Policy</h1>
          <p className="text-gray-600 mb-4 sm:mb-8 text-sm sm:text-base">Last updated: July 2, 2025</p>
        </div>

        <div className="bg-white shadow rounded-lg">
          <div className="px-3 py-4 sm:p-6">
            <div className="prose max-w-none text-xs sm:text-sm md:text-base">
              <section className="mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-2 sm:mb-4">1. What Are Cookies</h2>
                <p className="text-gray-700 mb-2 sm:mb-4">
                  As is common practice with almost all professional websites, this site uses cookies, which are tiny files that are downloaded to your computer, to improve your experience. This page describes what information they gather, how we use it, and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from being stored; however, this may downgrade or 'break' certain elements of the site's functionality.
                </p>
              </section>

              <section className="mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-2 sm:mb-4">2. How We Use Cookies</h2>
                <p className="text-gray-700 mb-2 sm:mb-4">
                  We use cookies for a variety of reasons detailed below. Unfortunately, in most cases, there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.
                </p>
              </section>

              <section className="mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-2 sm:mb-4">3. The Cookies We Set</h2>
                <p className="text-gray-700 mb-2 sm:mb-4">
                  When you submit data through a form such as those found on contact pages or comment forms, cookies may be set to remember your user details for future correspondence.
                </p>
                <ul className="list-disc pl-5 sm:pl-6 text-gray-700 space-y-1 sm:space-y-2 mb-3 sm:mb-4">
                  <li><strong>Site preferences cookies:</strong> In order to provide you with a great experience on this site, we provide the functionality to set your preferences for how this site runs when you use it. In order to remember your preferences, we need to set cookies so that this information can be called whenever you interact with a page that is affected by your preferences.</li>
                  <li><strong>Third-party analytics:</strong> We use third-party analytics services to help us understand how our website is used. These services may use cookies to collect information about your use of our website, including your IP address, which may be transmitted to and stored by the service provider.</li>
                </ul>
              </section>

              <section className="mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-2 sm:mb-4">4. Third-Party Cookies</h2>
                <p className="text-gray-700 mb-2 sm:mb-4">
                  In some special cases, we also use cookies provided by trusted third parties. The following section details which third-party cookies you might encounter through this site:
                </p>
                <ul className="list-disc pl-5 sm:pl-6 text-gray-700 space-y-1 sm:space-y-2 mb-3 sm:mb-4">
                  <li>This site uses Google Analytics which is one of the most widespread and trusted analytics solutions on the web for helping us to understand how you use the site and ways that we can improve your experience. These cookies may track things such as how long you spend on the site and the pages that you visit so we can continue to produce engaging content.</li>
                  <li>From time to time, we test new features and make subtle changes to the way that the site is delivered. When we are still testing new features, these cookies may be used to ensure that you receive a consistent experience while on the site while ensuring we understand which optimizations our users appreciate the most.</li>
                </ul>
              </section>

              <section className="mb-6 sm:mb-8">
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-2 sm:mb-4">5. Disabling Cookies</h2>
                <p className="text-gray-700 mb-2 sm:mb-4">
                  You can prevent the setting of cookies by adjusting the settings on your browser (see your browser's "Help" for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of this site. Therefore, it is recommended that you do not disable cookies.
                </p>
              </section>

              <section>
                <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 mb-2 sm:mb-4">6. More Information</h2>
                <p className="text-gray-700">
                  If you are looking for more information on our cookie policy, please contact us at:
                </p>
                <p className="text-gray-700 mt-2">
                  Email: <a href="mailto:info@biohazwastesolutions.com" className="text-emerald-600 hover:underline">info@biohazwastesolutions.com</a><br />
                  Phone: +256 393 254458 / +256 782 833711
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
